import axios from "axios";

import auth from "./auth";

import {Tracker} from "../types";
import { API_URL } from "./constants";

type User = {
    username: string;
    token: string;
    roles: string[];
}

type App = {
    name: string;
    version: string;
}

type UpdateTracker = {
    id: number,
    name: string,
    updatable: boolean,
    server_url: string,
    server_port: number,
}

type RedirectTarget = {
    url: string,
    port: number,
}

export function check(): Promise<boolean> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/token/check')
        .then(url => axios.get(url, {headers: auth.headers()}))
        .then(response => response.status !== 200 ? false : true)
}
export function login(username: string, password: string): Promise<User> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/user/login')
        .then(url => axios.post(url, {username, password}))
        .then(response => response.status !== 200 ? Promise.reject() : response.data)
}
export function app(): Promise<App> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/app')
        .then(url => axios.get(url))
        .then(response => response.status !== 200 ? Promise.reject() : response.data)
}

export function trackers(): Promise<Tracker[]> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/trackers')
        .then(url => axios.get(url, {headers: auth.headers()}))
        .then(response => response.status !== 200 ? Promise.reject() : response.data)
}

export function tracker(id: number): Promise<Tracker> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/tracker/'+id)
        .then(url => axios.get(url, {headers: auth.headers()}))
        .then(response => response.status !== 200 ? Promise.reject() : response.data)
}

export async function servers(): Promise<[{id: number, name: string, port: string}]> {
    try {
        const url = API_URL + '/api/v1/servers';
        const response = await axios.get(url, {headers: auth.headers()});
        if (response.status !== 200) {
            throw new Error('Loading servers failed');
        }
        return response.data;
    } catch (error) {
        throw error;
    }
}

export function save(item: UpdateTracker): Promise<void> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/tracker/'+item.id)
        .then(url => axios.put(url, item, {headers: auth.headers()}))
        .then(response => response.status !== 200 ? Promise.reject() : response.data)

}

export async function redirectAll(trackers: Tracker[], target: RedirectTarget): Promise<void> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/tracker/bulk/redirect')
        .then(url => axios.put(url, {ids: trackers.map(t => t.id), server_url: target.url, server_port: target.port}, {headers: auth.headers()}))
        .then(response => response.status !== 200 ? Promise.reject() : response.data)
}

export function remove(id: number): Promise<void> {
    return Promise.resolve()
        .then(() => API_URL + '/api/v1/tracker/'+id)
        .then(url => axios.delete(url, {headers: auth.headers()}))
        .then(response => response.status !== 201 ? Promise.reject() : response.data)
}

export async function sendtofleet(hardware_id: string, number: string, type: string, firmware: string) {
    try {
        const url = API_URL + '/api/v1/sendtofleet';
        const response = await axios.post(url, {hardware_id, number, type, firmware}, {headers: auth.headers()});
        if (response.status !== 200)
        {
            throw new Error('Send to fleet failed');
        }
        return response.data;
    } catch (error) {
        throw error;
    }
}

const EndPoint = {
    check,
    login,
    app,
    trackers,
    tracker,
    save,
    redirectAll,
    remove,
    servers,
    sendtofleet,
}

export default EndPoint;